<app-tab-form-modal [showSave]="false" [header]="header">
  @if (fields) {
    <formly-form [fields]="fields" [model]="creditCheck"></formly-form>
  }

  <div class="row">
    <div class="col-xl-6">
      <app-grid
        stateKey="CustomerCreditCheck"
        gridCssClass="tab-grid"
        i18n-header
        header="Accounts Information"
        [columnDefs]="columnDefs"
        [rowData]="creditCheckDetails"
        [showDelete]="false"
      ></app-grid>
    </div>
    <div class="col-xl-6">
      <app-customer-credit-sales-orders [customerId]="customerId" [liveOrders]="true">
      </app-customer-credit-sales-orders>
    </div>
  </div>
</app-tab-form-modal>
